/**
 * Studio 顶部 Home 图标底部文案（仅此映射生效，不读接口）。
 * 未配置的 studio_code 不展示底部文案。
 */
export interface IStudioHomeCardLabelEntry {
  nameEn: string;
  nameCn: string;
}

export const STUDIO_HOME_CARD_LABEL_BY_STUDIO_CODE: Record<
string,
IStudioHomeCardLabelEntry
> = {
  funcom: {
    nameEn: 'Funcom Business',
    nameCn: 'Funcom Business',
  },
};
